import { Injectable } from '@angular/core';
import { UnitsSettings } from '../models/unitsSettings';
import { wpd as wpd } from '../../js/wpd_node';
import 'jimp/browser/lib/jimp';
/*import Jimp from 'jimp';*/
import { EngineDataPoint } from '../models/engine-data';
import { UserPreferences } from '../models/user-preferences';
import { TorqueUnits } from '../models/torque-units';

const { Jimp } = window as typeof window & { Jimp: any }

@Injectable({
  providedIn: 'root'
})
export class DigitizerService {



  constructor() { }

  async digitizeImage(file: File, minRPM: number, maxRPM: number, maxTorque: number, userPreferences: UserPreferences) {

    const buffer = await file.arrayBuffer();
    let img = await Jimp.read(buffer);

    // load base project
    let plotData = new wpd.PlotData();
    let engineData = [];
    let project = img.bitmap.width == 1920 ? this.loadProject1080p(minRPM, maxRPM, maxTorque) : this.loadProject4k(minRPM, maxRPM, maxTorque);

    plotData.deserialize(project);

    // clear existing datasets and re-run auto-extraction
    for (let ds of plotData.getDatasets()) {
      ds.clearAll();
      let autoDetector = plotData.getAutoDetectionDataForDataset(ds);
      if (autoDetector == null) {
        console.log('missing autodetector for: ' + ds.name);
        continue;
      }
      let axes = plotData.getAxesForDataset(ds);
      autoDetector.imageWidth = img.bitmap.width;
      autoDetector.imageHeight = img.bitmap.height;
      autoDetector.generateBinaryData(img.bitmap);
      autoDetector.algorithm.run(autoDetector, ds, axes);

      console.log('Points detected: ' + ds.getCount());

      engineData = [];
      for (let ptIdx = 0; ptIdx < ds.getCount(); ptIdx++) {
        let pt = ds.getPixel(ptIdx);
        let data = axes.pixelToData(pt.x, pt.y);
        data[1] = TorqueUnits.torqueTolbft(data[1], userPreferences.torqueUnits.display);
        let ed: EngineDataPoint = {
          rpm: data[0],
          torque: data[1],
          power: (data[0] * data[1]) / 5252
        };

        engineData.push(ed);
      }
    }
    return engineData;
  }


  loadProject1080p(minRPM: number, maxRPM: number, maxTorque: number): any {
    return {
      "version": [
        4,
        2
      ],
      "axesColl": [
        {
          "name": "XY",
          "type": "XYAxes",
          "isLogX": false,
          "isLogY": false,
          "noRotation": false,
          "calibrationPoints": [
            {
              "px": 1133.3081285444234,
              "py": 342.9867674858223,
              "dx": `${minRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 1490.8128544423441,
              "py": 342.9867674858223,
              "dx": `${maxRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 1133.3081285444234,
              "py": 342.9867674858223,
              "dx": `${minRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 1133.3081285444234,
              "py": 138.82797731569,
              "dx": `${maxRPM}`,
              "dy": `${maxTorque}`,
              "dz": null
            }
          ]
        }
      ],
      "datasetColl": [
        {
          "name": "Default Dataset",
          "axesName": "XY",
          "colorRGB": [
            200,
            0,
            0,
            255
          ],
          "metadataKeys": [],
          "data": [
          ],
          "autoDetectionData": {
            "fgColor": [
              152,
              153,
              153
            ],
            "bgColor": [
              20,
              25,
              28
            ],
            "mask": [
              [
                264174,
                357
              ],
              [
                266094,
                357
              ],
              [
                268014,
                357
              ],
              [
                269934,
                357
              ],
              [
                271854,
                357
              ],
              [
                273774,
                357
              ],
              [
                275694,
                357
              ],
              [
                277614,
                357
              ],
              [
                279534,
                357
              ],
              [
                281454,
                357
              ],
              [
                283374,
                357
              ],
              [
                285294,
                357
              ],
              [
                287214,
                357
              ],
              [
                289134,
                357
              ],
              [
                291054,
                357
              ],
              [
                292974,
                357
              ],
              [
                294894,
                357
              ],
              [
                296814,
                313
              ],
              [
                297128,
                43
              ],
              [
                298734,
                357
              ],
              [
                300654,
                357
              ],
              [
                302574,
                315
              ],
              [
                302890,
                41
              ],
              [
                304494,
                357
              ],
              [
                306414,
                357
              ],
              [
                308334,
                357
              ],
              [
                310254,
                357
              ],
              [
                312174,
                238
              ],
              [
                312413,
                118
              ],
              [
                314094,
                357
              ],
              [
                316014,
                238
              ],
              [
                316253,
                118
              ],
              [
                317934,
                357
              ],
              [
                319854,
                357
              ],
              [
                321774,
                357
              ],
              [
                323694,
                357
              ],
              [
                325614,
                357
              ],
              [
                327534,
                357
              ],
              [
                329454,
                357
              ],
              [
                331374,
                357
              ],
              [
                333294,
                357
              ],
              [
                335214,
                357
              ],
              [
                337134,
                357
              ],
              [
                339054,
                357
              ],
              [
                340974,
                357
              ],
              [
                342894,
                357
              ],
              [
                344814,
                357
              ],
              [
                346734,
                357
              ],
              [
                348654,
                357
              ],
              [
                350574,
                357
              ],
              [
                352494,
                357
              ],
              [
                354414,
                357
              ],
              [
                356334,
                357
              ],
              [
                358254,
                357
              ],
              [
                360174,
                357
              ],
              [
                362094,
                151
              ],
              [
                362246,
                205
              ],
              [
                364014,
                357
              ],
              [
                365934,
                357
              ],
              [
                367854,
                357
              ],
              [
                369774,
                241
              ],
              [
                370016,
                115
              ],
              [
                371694,
                357
              ],
              [
                373614,
                357
              ],
              [
                375534,
                357
              ],
              [
                377454,
                171
              ],
              [
                377626,
                185
              ],
              [
                379374,
                357
              ],
              [
                381294,
                357
              ],
              [
                383214,
                357
              ],
              [
                385134,
                357
              ],
              [
                387054,
                357
              ],
              [
                388974,
                357
              ],
              [
                390894,
                357
              ],
              [
                392814,
                357
              ],
              [
                394734,
                357
              ],
              [
                396654,
                357
              ],
              [
                398574,
                357
              ],
              [
                400494,
                357
              ],
              [
                402414,
                357
              ],
              [
                404334,
                357
              ],
              [
                406254,
                357
              ],
              [
                408174,
                357
              ],
              [
                410094,
                228
              ],
              [
                410323,
                128
              ],
              [
                412014,
                357
              ],
              [
                413934,
                357
              ],
              [
                415854,
                357
              ],
              [
                417774,
                357
              ],
              [
                419694,
                357
              ],
              [
                421614,
                357
              ],
              [
                423534,
                357
              ],
              [
                425454,
                357
              ],
              [
                427374,
                357
              ],
              [
                429294,
                357
              ],
              [
                431214,
                357
              ],
              [
                433134,
                357
              ],
              [
                435054,
                357
              ],
              [
                436974,
                357
              ],
              [
                438894,
                357
              ],
              [
                440814,
                357
              ],
              [
                442734,
                357
              ],
              [
                444654,
                357
              ],
              [
                446574,
                357
              ],
              [
                448494,
                357
              ],
              [
                450414,
                357
              ],
              [
                452334,
                357
              ],
              [
                454254,
                357
              ],
              [
                456174,
                357
              ],
              [
                458094,
                357
              ],
              [
                460014,
                357
              ],
              [
                461934,
                357
              ],
              [
                463854,
                357
              ],
              [
                465774,
                357
              ],
              [
                467694,
                357
              ],
              [
                469614,
                357
              ],
              [
                471534,
                357
              ],
              [
                473454,
                357
              ],
              [
                475374,
                357
              ],
              [
                477294,
                357
              ],
              [
                479214,
                357
              ],
              [
                481134,
                357
              ],
              [
                483054,
                357
              ],
              [
                484974,
                357
              ],
              [
                486894,
                357
              ],
              [
                488814,
                357
              ],
              [
                490734,
                357
              ],
              [
                492654,
                357
              ],
              [
                494574,
                357
              ],
              [
                496494,
                357
              ],
              [
                498414,
                357
              ],
              [
                500334,
                357
              ],
              [
                502254,
                357
              ],
              [
                504174,
                45
              ],
              [
                504220,
                311
              ],
              [
                506094,
                357
              ],
              [
                508014,
                357
              ],
              [
                509934,
                357
              ],
              [
                511854,
                357
              ],
              [
                513774,
                357
              ],
              [
                515694,
                357
              ],
              [
                517614,
                357
              ],
              [
                519534,
                357
              ],
              [
                521454,
                357
              ],
              [
                523374,
                357
              ],
              [
                525294,
                357
              ],
              [
                527214,
                357
              ],
              [
                529134,
                357
              ],
              [
                531054,
                357
              ],
              [
                532974,
                357
              ],
              [
                534894,
                357
              ],
              [
                536814,
                357
              ],
              [
                538734,
                357
              ],
              [
                540654,
                357
              ],
              [
                542574,
                357
              ],
              [
                544494,
                357
              ],
              [
                546414,
                357
              ],
              [
                548334,
                145
              ],
              [
                548480,
                211
              ],
              [
                550254,
                357
              ],
              [
                552174,
                357
              ],
              [
                554094,
                357
              ],
              [
                556014,
                357
              ],
              [
                557934,
                357
              ],
              [
                559854,
                357
              ],
              [
                561774,
                357
              ],
              [
                563694,
                357
              ],
              [
                565614,
                357
              ],
              [
                567534,
                357
              ],
              [
                569454,
                357
              ],
              [
                571374,
                357
              ],
              [
                573294,
                357
              ],
              [
                575214,
                357
              ],
              [
                577134,
                357
              ],
              [
                579054,
                357
              ],
              [
                580974,
                357
              ],
              [
                582894,
                357
              ],
              [
                584814,
                357
              ],
              [
                586734,
                357
              ],
              [
                588654,
                357
              ],
              [
                590574,
                357
              ],
              [
                592494,
                357
              ],
              [
                594414,
                357
              ],
              [
                596334,
                357
              ],
              [
                598254,
                357
              ],
              [
                600174,
                357
              ],
              [
                602094,
                357
              ],
              [
                604014,
                357
              ],
              [
                605934,
                357
              ],
              [
                607854,
                357
              ],
              [
                609774,
                357
              ],
              [
                611694,
                357
              ],
              [
                613614,
                36
              ],
              [
                613651,
                320
              ],
              [
                615534,
                357
              ],
              [
                617454,
                357
              ],
              [
                619374,
                357
              ],
              [
                621294,
                357
              ],
              [
                623214,
                357
              ],
              [
                625134,
                357
              ],
              [
                627054,
                357
              ],
              [
                628974,
                357
              ],
              [
                630894,
                357
              ],
              [
                632814,
                357
              ],
              [
                634734,
                357
              ],
              [
                636654,
                357
              ],
              [
                638574,
                357
              ],
              [
                640494,
                357
              ],
              [
                642414,
                357
              ],
              [
                644334,
                357
              ],
              [
                646254,
                357
              ],
              [
                648174,
                357
              ],
              [
                650094,
                357
              ],
              [
                652014,
                357
              ],
              [
                653934,
                357
              ],
              [
                655854,
                357
              ],
              [
                657774,
                357
              ]
            ],
            "colorDetectionMode": "fg",
            "colorDistance": 10,
            "algorithm": {
              "algoType": "AveragingWindowAlgo",
              "xStep": 20,
              "yStep": 20
            },
            "name": 0,
            "imageWidth": 1920,
            "imageHeight": 1080
          }
        }
      ],
      "measurementColl": []
    };
  }

  loadProject4k(minRPM: number, maxRPM: number, maxTorque: number): any {
    return {
      "version": [
        4,
        2
      ],
      "axesColl": [
        {
          "name": "XY",
          "type": "XYAxes",
          "isLogX": false,
          "isLogY": false,
          "noRotation": false,
          "calibrationPoints": [
            {
              "px": 2244.072207052674,
              "py": 684.0883101122548,
              "dx": `${minRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 2955.8741160820564,
              "py": 684.0883101122548,
              "dx": `${maxRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 2244.072207052674,
              "py": 684.0883101122548,
              "dx": `${minRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 2244.072207052674,
              "py": 278.59459964059846,
              "dx": `${maxRPM}`,
              "dy": `${maxTorque}`,
              "dz": null
            }
          ]
        }
      ],
      "datasetColl": [
        {
          "name": "Default Dataset",
          "axesName": "XY",
          "colorRGB": [
            200,
            0,
            0,
            255
          ],
          "metadataKeys": [],
          "data": [],
          "autoDetectionData": {
            "fgColor": [
              152,
              153,
              153
            ],
            "bgColor": [
              20,
              25,
              28
            ],
            "mask": [
              [
                1065924,
                712
              ],
              [
                1069764,
                712
              ],
              [
                1073604,
                712
              ],
              [
                1077444,
                712
              ],
              [
                1081284,
                712
              ],
              [
                1085124,
                712
              ],
              [
                1088964,
                712
              ],
              [
                1092804,
                712
              ],
              [
                1096644,
                712
              ],
              [
                1100484,
                712
              ],
              [
                1104324,
                712
              ],
              [
                1108164,
                712
              ],
              [
                1112004,
                712
              ],
              [
                1115844,
                712
              ],
              [
                1119684,
                712
              ],
              [
                1123524,
                712
              ],
              [
                1127364,
                712
              ],
              [
                1131204,
                712
              ],
              [
                1135044,
                712
              ],
              [
                1138884,
                712
              ],
              [
                1142724,
                712
              ],
              [
                1146564,
                712
              ],
              [
                1150404,
                712
              ],
              [
                1154244,
                712
              ],
              [
                1158084,
                712
              ],
              [
                1161924,
                712
              ],
              [
                1165764,
                712
              ],
              [
                1169604,
                712
              ],
              [
                1173444,
                712
              ],
              [
                1177284,
                712
              ],
              [
                1181124,
                712
              ],
              [
                1184964,
                712
              ],
              [
                1188804,
                712
              ],
              [
                1192644,
                712
              ],
              [
                1196484,
                712
              ],
              [
                1200324,
                712
              ],
              [
                1204164,
                712
              ],
              [
                1208004,
                712
              ],
              [
                1211844,
                712
              ],
              [
                1215684,
                712
              ],
              [
                1219524,
                712
              ],
              [
                1223364,
                712
              ],
              [
                1227204,
                712
              ],
              [
                1231044,
                712
              ],
              [
                1234884,
                712
              ],
              [
                1238724,
                712
              ],
              [
                1242564,
                712
              ],
              [
                1246404,
                712
              ],
              [
                1250244,
                712
              ],
              [
                1254084,
                712
              ],
              [
                1257924,
                712
              ],
              [
                1261764,
                712
              ],
              [
                1265604,
                712
              ],
              [
                1269444,
                712
              ],
              [
                1273284,
                712
              ],
              [
                1277124,
                712
              ],
              [
                1280964,
                712
              ],
              [
                1284804,
                55
              ],
              [
                1284860,
                656
              ],
              [
                1288644,
                712
              ],
              [
                1292484,
                712
              ],
              [
                1296324,
                712
              ],
              [
                1300164,
                712
              ],
              [
                1304004,
                712
              ],
              [
                1307844,
                712
              ],
              [
                1311684,
                712
              ],
              [
                1315524,
                712
              ],
              [
                1319364,
                712
              ],
              [
                1323204,
                712
              ],
              [
                1327044,
                712
              ],
              [
                1330884,
                712
              ],
              [
                1334724,
                655
              ],
              [
                1335380,
                56
              ],
              [
                1338564,
                712
              ],
              [
                1342404,
                712
              ],
              [
                1346244,
                712
              ],
              [
                1350084,
                712
              ],
              [
                1353924,
                712
              ],
              [
                1357764,
                712
              ],
              [
                1361604,
                712
              ],
              [
                1365444,
                712
              ],
              [
                1369284,
                712
              ],
              [
                1373124,
                712
              ],
              [
                1376964,
                712
              ],
              [
                1380804,
                712
              ],
              [
                1384644,
                712
              ],
              [
                1388484,
                712
              ],
              [
                1392324,
                712
              ],
              [
                1396164,
                712
              ],
              [
                1400004,
                712
              ],
              [
                1403844,
                712
              ],
              [
                1407684,
                712
              ],
              [
                1411524,
                712
              ],
              [
                1415364,
                712
              ],
              [
                1419204,
                712
              ],
              [
                1423044,
                712
              ],
              [
                1426884,
                712
              ],
              [
                1430724,
                712
              ],
              [
                1434564,
                712
              ],
              [
                1438404,
                108
              ],
              [
                1438513,
                603
              ],
              [
                1442244,
                712
              ],
              [
                1446084,
                712
              ],
              [
                1449924,
                712
              ],
              [
                1453764,
                712
              ],
              [
                1457604,
                712
              ],
              [
                1461444,
                712
              ],
              [
                1465284,
                712
              ],
              [
                1469124,
                712
              ],
              [
                1472964,
                712
              ],
              [
                1476804,
                712
              ],
              [
                1480644,
                712
              ],
              [
                1484484,
                712
              ],
              [
                1488324,
                712
              ],
              [
                1492164,
                712
              ],
              [
                1496004,
                712
              ],
              [
                1499844,
                367
              ],
              [
                1500212,
                344
              ],
              [
                1503684,
                712
              ],
              [
                1507524,
                712
              ],
              [
                1511364,
                712
              ],
              [
                1515204,
                712
              ],
              [
                1519044,
                712
              ],
              [
                1522884,
                693
              ],
              [
                1523578,
                18
              ],
              [
                1526724,
                712
              ],
              [
                1530564,
                712
              ],
              [
                1534404,
                712
              ],
              [
                1538244,
                712
              ],
              [
                1542084,
                712
              ],
              [
                1545924,
                712
              ],
              [
                1549764,
                712
              ],
              [
                1553604,
                712
              ],
              [
                1557444,
                712
              ],
              [
                1561284,
                712
              ],
              [
                1565124,
                712
              ],
              [
                1568964,
                712
              ],
              [
                1572804,
                712
              ],
              [
                1576644,
                712
              ],
              [
                1580484,
                712
              ],
              [
                1584324,
                712
              ],
              [
                1588164,
                712
              ],
              [
                1592004,
                712
              ],
              [
                1595844,
                712
              ],
              [
                1599684,
                712
              ],
              [
                1603524,
                712
              ],
              [
                1607364,
                712
              ],
              [
                1611204,
                712
              ],
              [
                1615044,
                712
              ],
              [
                1618884,
                712
              ],
              [
                1622724,
                712
              ],
              [
                1626564,
                712
              ],
              [
                1630404,
                712
              ],
              [
                1634244,
                712
              ],
              [
                1638084,
                712
              ],
              [
                1641924,
                712
              ],
              [
                1645764,
                712
              ],
              [
                1649604,
                712
              ],
              [
                1653444,
                712
              ],
              [
                1657284,
                712
              ],
              [
                1661124,
                712
              ],
              [
                1664964,
                712
              ],
              [
                1668804,
                712
              ],
              [
                1672644,
                712
              ],
              [
                1676484,
                712
              ],
              [
                1680324,
                712
              ],
              [
                1684164,
                712
              ],
              [
                1688004,
                712
              ],
              [
                1691844,
                712
              ],
              [
                1695684,
                712
              ],
              [
                1699524,
                712
              ],
              [
                1703364,
                712
              ],
              [
                1707204,
                712
              ],
              [
                1711044,
                712
              ],
              [
                1714884,
                712
              ],
              [
                1718724,
                712
              ],
              [
                1722564,
                712
              ],
              [
                1726404,
                712
              ],
              [
                1730244,
                74
              ],
              [
                1730319,
                637
              ],
              [
                1734084,
                712
              ],
              [
                1737924,
                712
              ],
              [
                1741764,
                712
              ],
              [
                1745604,
                712
              ],
              [
                1749444,
                712
              ],
              [
                1753284,
                712
              ],
              [
                1757124,
                712
              ],
              [
                1760964,
                712
              ],
              [
                1764804,
                712
              ],
              [
                1768644,
                712
              ],
              [
                1772484,
                712
              ],
              [
                1776324,
                712
              ],
              [
                1780164,
                712
              ],
              [
                1784004,
                712
              ],
              [
                1787844,
                712
              ],
              [
                1791684,
                712
              ],
              [
                1795524,
                712
              ],
              [
                1799364,
                712
              ],
              [
                1803204,
                712
              ],
              [
                1807044,
                712
              ],
              [
                1810884,
                712
              ],
              [
                1814724,
                712
              ],
              [
                1818564,
                712
              ],
              [
                1822404,
                712
              ],
              [
                1826244,
                712
              ],
              [
                1830084,
                712
              ],
              [
                1833924,
                712
              ],
              [
                1837764,
                712
              ],
              [
                1841604,
                712
              ],
              [
                1845444,
                712
              ],
              [
                1849284,
                712
              ],
              [
                1853124,
                712
              ],
              [
                1856964,
                712
              ],
              [
                1860804,
                712
              ],
              [
                1864644,
                712
              ],
              [
                1868484,
                712
              ],
              [
                1872324,
                712
              ],
              [
                1876164,
                712
              ],
              [
                1880004,
                712
              ],
              [
                1883844,
                712
              ],
              [
                1887684,
                712
              ],
              [
                1891524,
                712
              ],
              [
                1895364,
                712
              ],
              [
                1899204,
                712
              ],
              [
                1903044,
                712
              ],
              [
                1906884,
                712
              ],
              [
                1910724,
                246
              ],
              [
                1910971,
                465
              ],
              [
                1914564,
                712
              ],
              [
                1918404,
                712
              ],
              [
                1922244,
                712
              ],
              [
                1926084,
                712
              ],
              [
                1929924,
                712
              ],
              [
                1933764,
                712
              ],
              [
                1937604,
                712
              ],
              [
                1941444,
                712
              ],
              [
                1945284,
                75
              ],
              [
                1945360,
                636
              ],
              [
                1949124,
                712
              ],
              [
                1952964,
                638
              ],
              [
                1953603,
                73
              ],
              [
                1956804,
                712
              ],
              [
                1960644,
                712
              ],
              [
                1964484,
                712
              ],
              [
                1968324,
                712
              ],
              [
                1972164,
                712
              ],
              [
                1976004,
                712
              ],
              [
                1979844,
                712
              ],
              [
                1983684,
                712
              ],
              [
                1987524,
                712
              ],
              [
                1991364,
                712
              ],
              [
                1995204,
                712
              ],
              [
                1999044,
                712
              ],
              [
                2002884,
                712
              ],
              [
                2006724,
                712
              ],
              [
                2010564,
                712
              ],
              [
                2014404,
                712
              ],
              [
                2018244,
                712
              ],
              [
                2022084,
                712
              ],
              [
                2025924,
                712
              ],
              [
                2029764,
                712
              ],
              [
                2033604,
                712
              ],
              [
                2037444,
                712
              ],
              [
                2041284,
                712
              ],
              [
                2045124,
                712
              ],
              [
                2048964,
                712
              ],
              [
                2052804,
                712
              ],
              [
                2056644,
                712
              ],
              [
                2060484,
                712
              ],
              [
                2064324,
                712
              ],
              [
                2068164,
                712
              ],
              [
                2072004,
                712
              ],
              [
                2075844,
                712
              ],
              [
                2079684,
                712
              ],
              [
                2083524,
                712
              ],
              [
                2087364,
                712
              ],
              [
                2091204,
                712
              ],
              [
                2095044,
                712
              ],
              [
                2098884,
                712
              ],
              [
                2102724,
                712
              ],
              [
                2106564,
                712
              ],
              [
                2110404,
                712
              ],
              [
                2114244,
                712
              ],
              [
                2118084,
                712
              ],
              [
                2121924,
                712
              ],
              [
                2125764,
                712
              ],
              [
                2129604,
                712
              ],
              [
                2133444,
                712
              ],
              [
                2137284,
                712
              ],
              [
                2141124,
                712
              ],
              [
                2144964,
                712
              ],
              [
                2148804,
                712
              ],
              [
                2152644,
                712
              ],
              [
                2156484,
                712
              ],
              [
                2160324,
                712
              ],
              [
                2164164,
                712
              ],
              [
                2168004,
                712
              ],
              [
                2171844,
                712
              ],
              [
                2175684,
                712
              ],
              [
                2179524,
                712
              ],
              [
                2183364,
                712
              ],
              [
                2187204,
                712
              ],
              [
                2191044,
                712
              ],
              [
                2194884,
                712
              ],
              [
                2198724,
                712
              ],
              [
                2202564,
                712
              ],
              [
                2206404,
                712
              ],
              [
                2210244,
                712
              ],
              [
                2214084,
                712
              ],
              [
                2217924,
                712
              ],
              [
                2221764,
                712
              ],
              [
                2225604,
                712
              ],
              [
                2229444,
                712
              ],
              [
                2233284,
                712
              ],
              [
                2237124,
                712
              ],
              [
                2240964,
                712
              ],
              [
                2244804,
                712
              ],
              [
                2248644,
                712
              ],
              [
                2252484,
                712
              ],
              [
                2256324,
                712
              ],
              [
                2260164,
                712
              ],
              [
                2264004,
                712
              ],
              [
                2267844,
                712
              ],
              [
                2271684,
                712
              ],
              [
                2275524,
                712
              ],
              [
                2279364,
                712
              ],
              [
                2283204,
                712
              ],
              [
                2287044,
                712
              ],
              [
                2290884,
                712
              ],
              [
                2294724,
                712
              ],
              [
                2298564,
                712
              ],
              [
                2302404,
                712
              ],
              [
                2306244,
                712
              ],
              [
                2310084,
                712
              ],
              [
                2313924,
                133
              ],
              [
                2314058,
                578
              ],
              [
                2317764,
                712
              ],
              [
                2321604,
                712
              ],
              [
                2325444,
                712
              ],
              [
                2329284,
                712
              ],
              [
                2333124,
                712
              ],
              [
                2336964,
                712
              ],
              [
                2340804,
                712
              ],
              [
                2344644,
                712
              ],
              [
                2348484,
                712
              ],
              [
                2352324,
                712
              ],
              [
                2356164,
                712
              ],
              [
                2360004,
                712
              ],
              [
                2363844,
                712
              ],
              [
                2367684,
                712
              ],
              [
                2371524,
                712
              ],
              [
                2375364,
                712
              ],
              [
                2379204,
                712
              ],
              [
                2383044,
                712
              ],
              [
                2386884,
                712
              ],
              [
                2390724,
                712
              ],
              [
                2394564,
                712
              ],
              [
                2398404,
                712
              ],
              [
                2402244,
                712
              ],
              [
                2406084,
                712
              ],
              [
                2409924,
                712
              ],
              [
                2413764,
                712
              ],
              [
                2417604,
                712
              ],
              [
                2421444,
                712
              ],
              [
                2425284,
                712
              ],
              [
                2429124,
                712
              ],
              [
                2432964,
                712
              ],
              [
                2436804,
                712
              ],
              [
                2440644,
                712
              ],
              [
                2444484,
                712
              ],
              [
                2448324,
                712
              ],
              [
                2452164,
                712
              ],
              [
                2456004,
                712
              ],
              [
                2459844,
                712
              ],
              [
                2463684,
                712
              ],
              [
                2467524,
                712
              ],
              [
                2471364,
                712
              ],
              [
                2475204,
                712
              ],
              [
                2479044,
                712
              ],
              [
                2482884,
                712
              ],
              [
                2486724,
                712
              ],
              [
                2490564,
                712
              ],
              [
                2494404,
                712
              ],
              [
                2498244,
                712
              ],
              [
                2502084,
                712
              ],
              [
                2505924,
                712
              ],
              [
                2509764,
                712
              ],
              [
                2513604,
                712
              ],
              [
                2517444,
                712
              ],
              [
                2521284,
                712
              ],
              [
                2525124,
                712
              ],
              [
                2528964,
                712
              ],
              [
                2532804,
                712
              ],
              [
                2536644,
                712
              ],
              [
                2540484,
                712
              ],
              [
                2544324,
                712
              ],
              [
                2548164,
                712
              ],
              [
                2552004,
                712
              ],
              [
                2555844,
                712
              ],
              [
                2559684,
                712
              ],
              [
                2563524,
                712
              ],
              [
                2567364,
                712
              ],
              [
                2571204,
                712
              ],
              [
                2575044,
                712
              ],
              [
                2578884,
                712
              ],
              [
                2582724,
                712
              ],
              [
                2586564,
                712
              ],
              [
                2590404,
                712
              ],
              [
                2594244,
                712
              ],
              [
                2598084,
                712
              ],
              [
                2601924,
                712
              ],
              [
                2605764,
                712
              ],
              [
                2609604,
                712
              ],
              [
                2613444,
                712
              ],
              [
                2617284,
                712
              ],
              [
                2621124,
                712
              ],
              [
                2624964,
                712
              ]
            ],
            "colorDetectionMode": "fg",
            "colorDistance": 10,
            "algorithm": {
              "algoType": "AveragingWindowAlgo",
              "xStep": 40,
              "yStep": 40
            },
            "name": 1,
            "imageWidth": 3840,
            "imageHeight": 2160
          }
        }
      ],
      "measurementColl": []
    }
  }

  createRectifiedProject(minRPM: number, maxRPM: number, maxTorque: number): any {
    return {
      "version": [4, 2],
      "axesColl": [
        {
          "name": "XY",
          "type": "XYAxes",
          "isLogX": false,
          "isLogY": false,
          "noRotation": false,
          "calibrationPoints": [
            {
              "px": 100,
              "py": 450,
              "dx": `${minRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 700,
              "py": 450,
              "dx": `${maxRPM}`,
              "dy": "0",
              "dz": null
            },
            {
              "px": 100,
              "py": 50,
              "dx": `${minRPM}`,
              "dy": `${maxTorque}`,
              "dz": null
            },
            {
              "px": 700,
              "py": 50,
              "dx": `${maxRPM}`,
              "dy": `${maxTorque}`,
              "dz": null
            }
          ]
        }
      ],
      "datasetColl": [
        {
          "name": "Default Dataset",
          "axesName": "XY",
          "colorRGB": [200, 0, 0, 255],
          "metadataKeys": [],
          "data": [],
          "autoDetectionData": {
            "fgColor": [0, 200, 200], // Cyan curve color for GT7 ECU
            "bgColor": [29, 33, 37],  // Dark background
            "mask": [],
            "colorDetectionMode": "fg",
            "colorDistance": 120,
            "algorithm": {
              "algoType": "XStepWithInterpolationAlgo",
              "xmin": minRPM,
              "delx": 50,
              "xmax": maxRPM,
              "ymin": 0,
              "ymax": maxTorque,
              "smoothing": 10
            },
            "name": 0,
            "imageWidth": 800,
            "imageHeight": 500
          }
        }
      ],
      "measurementColl": []
    };
  }
}
